import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';
import getServiceAssociatedWithNode from './getServiceAssociatedWithNode';
import { needsAuth } from 'app/service/ServiceUtils';

// !!! IMPORTANT !!!
// This function affects the global flows redux state. You
// may need to make the same changes to both the beta-editor
// and classic-editor code. Edit with caution and test thoroughly.
const serviceNeedsAuth = (node: FlowNode, services: ServicesMap) => {
  const svc = getServiceAssociatedWithNode(node, services);
  return svc && needsAuth(svc);
};

export default serviceNeedsAuth;
